<div class="graph-container">
  <div class="title" *ngIf="model">{{getTitle()}}</div>
  <ng-container *ngIf="model">
    <p-chart [type]="model.type" [data]="model.data" [options]="model.options" height="23rem"
      [responsive]="true"></p-chart>
  </ng-container>
</div>